

























































import { Vue, Component } from 'vue-property-decorator';
import SearchBar from '@/components/next/SearchBar.vue';
import VoteButton from '../components/VoteButton.vue';
import { getVoteList, getRules } from '../api';
import { List, Lazyload, Dialog, Toast, Popup } from 'vant';
Vue.use(List).use(Lazyload).use(Dialog).use(Toast).use(Popup);
@Component({
  components: {
    SearchBar,
    VoteButton,
  },
})
export default class Votes extends Vue {
  tab: any = [
    { text: '银行', id: 0 },
    { text: '保险', id: 1 },
    { text: '融资担保', id: 2 },
    { text: '其他', id: 3 },
  ];
  activeType = 0;
  search = '';
  voteName: string = '2021project/q4/2021finance';
  list: any[] = [];
  page = 1;
  loading = false;
  popShow: boolean = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  show: boolean = true;
  rule: string = '';
  changeTab(item: any) {
    this.activeType = item.id;
    this.list = [];
    this.page = 1;
    this.loading = false;
    this.finished = false;
    this.loadingStatus = true;
    this.refreshing = false;
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 500);
  }
  onSearch() {
    this.finished = false;
    this.page = 1;
    this.list = [];
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 500);
  }
  clear() {
    this.list = [];
    this.page = 1;
    this.finished = false;
  }
  userInputChange(text: string) {
    this.search = text;
  }
  async created() {
    const res: any = await getRules();
    this.rule = res.data;
  }
  onLoad() {
    getVoteList(this.tab[this.activeType].text, this.page, this.search).then(
      (res: any) => {
        this.endListData(res);
      },
    );
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
  onShow() {
    this.popShow = true;
  }
  votSuccess(data: any, index: any) {
    this.list[index].votes = data;
    setTimeout(() => {
      this.$router.push('prize?id=1');
    }, 1500);
  }
  goPrize() {
    this.$router.push('prize?id=2');
  }
}
